import { useInfiniteQuery } from '@tanstack/react-query';
import { api } from '@/modules/common/api/index.ts';
import { useGetCurrentBusinessId } from '@/modules/common/hooks/useGetCurrentBusinessId.ts';
import {
  GetRegisterListPublicV1RegistersPublicGetParams,
  GetRegisterListResponse,
  GetRegisterListV1RegistersGetParams,
} from 'compliance-api';

export const REGISTERS_LIST_QUERY_KEY = 'vestra-compliance/registers-list';
export const PUBLIC_REGISTERS_LIST_QUERY_KEY = 'vestra-compliance/public-registers-list';

export const useRegistersListQuery = (
  payload: GetRegisterListV1RegistersGetParams,
  disabled = false,
) => {
  const { page, ...data } = payload;
  return useInfiniteQuery<GetRegisterListResponse>({
    queryKey: [REGISTERS_LIST_QUERY_KEY, JSON.stringify(data), useGetCurrentBusinessId()],
    staleTime: 1000 * 60 * 60 * 3, // 3 hours
    queryFn: async ({ pageParam = 0 }) => {
      const response = await api.v1.getRegisterListV1RegistersGet({
        ...data,
        page: typeof pageParam === 'number' && pageParam ? pageParam : pageParam?.page || page,
        filter_by_name: pageParam?.search || payload.filter_by_name,
      });
      return response.data;
    },
    keepPreviousData: true,
    retry: 2,
    getNextPageParam: ({ total, page, page_size }) => {
      const totalPage = Math.ceil(total / page_size);
      const hasMore = totalPage > page;
      if (hasMore) {
        return page + 1;
      }
    },
    enabled: !disabled,
  });
};

export const usePublicRegistersListQuery = (
  payload: GetRegisterListPublicV1RegistersPublicGetParams,
  disabled = false,
) => {
  const { page, ...data } = payload;
  return useInfiniteQuery<GetRegisterListResponse>({
    queryKey: [PUBLIC_REGISTERS_LIST_QUERY_KEY, JSON.stringify(data), useGetCurrentBusinessId()],
    staleTime: 1000 * 60 * 60 * 3, // 3 hours
    queryFn: async ({ pageParam = 0 }) => {
      const response = await api.v1.getRegisterListPublicV1RegistersPublicGet({
        ...data,
        page: typeof pageParam === 'number' && pageParam ? pageParam : pageParam?.page || page,
        filter_by_name: pageParam?.search || payload.filter_by_name,
      });
      return response.data;
    },
    keepPreviousData: true,
    retry: 2,
    getNextPageParam: ({ total, page, page_size }) => {
      const totalPage = Math.ceil(total / page_size);
      const hasMore = totalPage > page;
      if (hasMore) {
        return page + 1;
      }
    },
    enabled: !disabled,
  });
};
